import '../../style/reviewSlider.css'
import SliderWrapperNew from '../utils/SliderWrappernew'
import { connect } from 'react-redux'
import { getReview } from '../../actions'
import { useEffect } from 'react'
// import LazyFetchingHOC from '../utils/LazyFetchingHOC'
// import ReviewPlaceHolder from '../utils/ReviewPlaceHolder'
const ReviewSlider = (props) => {
    const { getReview } = props
    useEffect(() => {
        getReview()
    }, [getReview])
    return (
        <div className="review-content-container">
            <div className="inner-review-content containerAF max-width">
                <div className="review-content-heading">
                    <h1 className="review-title">Customer safety is our Priority</h1>
                    <p className="review-subs">What Customers are saying about our saftey standards</p>
                </div>
                <SliderWrapperNew height={props.mobileNav ? '160px' : '180px'} isImageSlider={false} sliderData={props.reviewData} review={true} mobileNav={props.mobileNav}/>
            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav: state.mobileNav,
        reviewData: state.mainReview,
    }
}

// const oldComponent = connect(mapStateToProps, { getReview })(ReviewSlider)
// const EnhansedReviewSlider = LazyFetchingHOC(oldComponent, ReviewPlaceHolder, '180px', true)
// export default EnhansedReviewSlider

export default connect(mapStateToProps, { getReview })(ReviewSlider)